import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Item from './Item';
/**
 * A BreadCrumb is a component which organise its childrens in row.
 * Each children is separated with _greater than_ symbol.
 * The main use of that component will be to display the client's history path.
 *
 * @return {jsx}
 */

var BreadCrumb = function BreadCrumb(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("ul", {
    className: className
  }, children);
};

BreadCrumb.Item = Item;
var node = PropTypes.node,
    string = PropTypes.string;
/**
 * PropTypes Validation.
 */

BreadCrumb.propTypes = {
  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: node.isRequired,

  /**
   * ClassName needed by styled components
   */
  className: string
};
/**
 * Default props
 */

BreadCrumb.defaultProps = {
  className: ''
};
var StyledBreadCrumb = styled(BreadCrumb).withConfig({
  displayName: "BreadCrumb__StyledBreadCrumb",
  componentId: "sc-1an26ru-0"
})(["display:inline-flex;align-items:center;flex-wrap:wrap;"]);
export default StyledBreadCrumb;